import { render, staticRenderFns } from "./SaleNoteDetails.vue?vue&type=template&id=2dc323da&scoped=true&"
import script from "./SaleNoteDetails.vue?vue&type=script&lang=js&"
export * from "./SaleNoteDetails.vue?vue&type=script&lang=js&"
import style0 from "./SaleNoteDetails.vue?vue&type=style&index=0&id=2dc323da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc323da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dc323da')) {
      api.createRecord('2dc323da', component.options)
    } else {
      api.reload('2dc323da', component.options)
    }
    module.hot.accept("./SaleNoteDetails.vue?vue&type=template&id=2dc323da&scoped=true&", function () {
      api.rerender('2dc323da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Invoices/NewSaleNote/SaleNoteDetails.vue"
export default component.exports